import Named from "../../types/base/Named";

const nameComparator = (a: Named, b: Named) =>
  (a.name ?? "").localeCompare(b.name ?? "");
export default nameComparator;
